import { Accept } from 'react-dropzone'

export const acceptedZervantInvoiceLogoFileFormats: Accept = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
}
